import { render } from "./PopupWithSlot.vue?vue&type=template&id=358b9244&scoped=true"
import script from "./PopupWithSlot.vue?vue&type=script&lang=js"
export * from "./PopupWithSlot.vue?vue&type=script&lang=js"

import "./PopupWithSlot.vue?vue&type=style&index=0&id=358b9244&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358b9244"]])

export default __exports__